import { RootState } from 'appHooks'

export const getSmsSection = (state: RootState) =>
  state.communication.smsMessages.filters.queryStatus

export const getSmsFilters = (state: RootState) =>
  state.communication.smsMessages.filters

export const getSmsLabel = (state: RootState) =>
  state.communication.smsMessages.filters.labelId

export const getSmsMessagesMarkedForActions = (state: RootState) =>
  state.communication.smsMessages.marked

export const isSmsMarkedForAction = (id: string) => (state: RootState) =>
  state.communication.smsMessages.marked.includes(id)

export const getCurrentSms = (state: RootState) =>
  state.communication.smsMessages.current

export const getSingleListSmsActionId = (state: RootState) =>
  state.communication.smsMessages.singleListActionId
